import { Image } from 'antd'

const AsanaIcon = (props) => {
  return <Image src="/thirdParties/asana.png" preview={false} {...props} />
}

export default AsanaIcon
